import { Sparkles, Bell } from "lucide-react";
import { Link } from "react-router-dom";

export default function ComingSoon({ title, description, eta = "Q3 2026" }) {
  return (
    <div data-testid={`coming-soon-${title}`} className="space-y-8">
      <div>
        <div className="overline mb-2">// ROADMAP</div>
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tight">{title}</h1>
        <p className="text-zinc-400 mt-2 max-w-2xl">{description}</p>
      </div>

      <div className="tactical-card p-10 max-w-3xl text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-orange/10 border border-brand-orange rounded-2xl mb-5 animate-pulse-glow">
          <Sparkles className="w-7 h-7 text-brand-orange" />
        </div>
        <h2 className="font-heading text-2xl font-bold uppercase tracking-tight mb-3">Coming Soon</h2>
        <p className="text-zinc-400 mb-1">This module is in active development.</p>
        <p className="font-mono-tabular text-xs text-zinc-500 mb-6">ETA · {eta}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/dashboard" className="btn-secondary"><Bell className="w-4 h-4" /> Notify Me</Link>
          <a href="https://discord.com" target="_blank" rel="noreferrer" className="btn-ghost border border-brand-line">Suggest a Feature</a>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { t: "Why?", d: "We focus on quality over breadth. Each module gets full Discord integration before shipping." },
          { t: "When?", d: `Live by ${eta}. Subscribe to release notes for early access.` },
          { t: "Vote", d: "Tell us which feature should ship next from the roadmap." },
        ].map((b) => (
          <div key={b.t} className="tactical-card p-5">
            <div className="overline mb-2">{b.t}</div>
            <p className="text-sm text-zinc-300">{b.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
